import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "onlysense-field" }
const _hoisted_2 = ["value", "placeholder"]




export default /*#__PURE__*/_defineComponent({
  __name: 'field',
  props: {
  value: [String, Number],
  placeholder: String,
  errorMessage: { type: String, default: "" },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      value: __props.value,
      placeholder: __props.placeholder,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:value', $event.target.value)))
    }, null, 40, _hoisted_2),
    _createElementVNode("div", {
      class: _normalizeClass([
        'onlysense-field__error',
        { 'onlysense-field__error--hide': !__props.errorMessage.length },
      ])
    }, _toDisplayString(__props.errorMessage), 3)
  ]))
}
}

})